const colors = {
  ourBlack: '#0E151C',
  deepBlue: '#151D28',
  ourWhite: '#FFFAEA',
  ourGreen: '#00BE85',
  greenMuted: '#009C6D',
  ourGray: '#494949',
  ourGrayTwo: '#6E6E6E',
  ourGrayThree: '#666',
  ourGrayFour: '#6666661A',
};

export default colors;
